import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import InputFileHook from '../Components/inputFileHook';
import TableDecisionRules from '../Components/tableDecisionRules';
import { toast, ToastContainer } from 'react-toastify';
import { API } from "aws-amplify";
import ModalRetakeAsessory from '../Components/modalRetakeAsessory';

export const ConfigurationFactsheets = () => {
	const { handleSubmit, register, reset, watch, getValues } = useForm();
	const [ fileName, setFileName ] = useState("Seleccione un archivo");
	const [ listFactsheets, setListFactsheets ] = useState([]);
	const [ listProducts, setListProducts ] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const[openModal, setOpenModal] = useState(false);

	const product = watch('product');
	const file = watch('file');
	const isDisabled = !product || !file || file.length === 0;
	
	const sanitizeText = (text, allowDot = false) => {
		return text
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.replace(allowDot ? /[^a-zA-Z0-9.-]/g : /[^a-zA-Z0-9-]/g, '');
	};

	const fileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

	const msgError = (msg) =>{
		toast.error(msg, {
			position: toast.POSITION.TOP_CENTER,
			className: "toast-modal"
		});
	};

	const onSubmit = async (data) => {
		setIsLoading(true);
		const metadata = data.file[0];

		if (metadata.type !== 'application/pdf') {
			return msgError("El archivo debe ser un PDF");
		}
    
    if (listProducts.length === 0) {
			setIsLoading(false);
      return msgError("No se han cargado los productos. Por favor, intente nuevamente más tarde.");
    }

		if (listFactsheets.some(f => f.name === sanitizeText(metadata.name, true))) {
			setIsLoading(false);
			return setOpenModal(true);
		}

		saveDocument(data);
	}

	const saveDocument = async (data) => {
    const fileBase64 = await fileToBase64(data.file[0]);

    const foundProduct = listProducts.find(p => p.value === data.product);
    const nombreProducto = foundProduct && foundProduct.name ? (foundProduct.name.split(' - ')[1] || '').trim() : '';

    const request = {
      codigoProducto: data.product,
      nombreProducto: sanitizeText(nombreProducto),
      nombreArchivo: sanitizeText(data.file[0].name, true),
      archivoEncoded: fileBase64.split(',')[1]
    };

		try {
			const response = await API.post("api-rentas", "/factsheets", {body: request});
			if (response.status === 200) {
				toast.success(response.message, {
					position: toast.POSITION.TOP_CENTER,
					className: "toast-modal-success"
				});
				reset();
				setFileName("Seleccione un archivo");
				getListFactsheets();
			} else {
				msgError(response.message);
			}
		} catch (error) {
			msgError(error.message);
		} finally {
			setIsLoading(false);
		}
	}

	const getListFactsheets = async () => {
		try {
			const response = await API.get("api-rentas", "/factsheets");
			if (response.status === 200) {
				setListFactsheets(response.data);
        const products = response.parametros.productos.map((product) => ({
          value: product.codigo,
          name: `${product.codigo} - ${product.descripcion}`
        }));
        setListProducts(products);
			}
			msgError(response.message);
		} catch (error) {
			msgError(error.message);
		}
	}

	useEffect(() => {
		getListFactsheets();
	}, []);

  return (
    <div className="configFormAS configFormAS__wrapper">
			<div className="configFormAS__container-titles">
				<p className="configFormAS__container-titles__title">
					Configuración <span>Factsheets Inversiones</span>
				</p>
				<p className="configFormAS__container-titles__sub-title">
					Cargue aquí los documentos
				</p>
			</div>
			<form onSubmit={handleSubmit(onSubmit)} className="configFormAS__form">
				<div className="configFormAS__form__input-container">
					<select
						name="product" 
						ref={register}
						className="configFormAS__form__select"
					>
						<option value="">Seleccione un producto</option>
						{listProducts.map((product) => (
							<option key={product.value} value={product.value}>
								{product.name}
							</option>
						))}
					</select>
					<label className="configFormAS__form__input-file">
						<InputFileHook name="file" accept={".pdf"} register={register} setFileName={setFileName}/>
						<span className="configFormAS__form__input-file__file-custom">{fileName}</span>
					</label>
				</div>
				<div className="configFormAS__form__btn-container">
					<button
						id="button_quote_vas1"
						type="submit"
						disabled={isDisabled || isLoading}
						className="configFormAS__form__btn-container__btn"
					>
						SUBIR ARCHIVO
					</button>
				</div>
			</form>
      <TableDecisionRules type="pdf" items={listFactsheets} />
			<ModalRetakeAsessory
				open={openModal}
				setOpen={setOpenModal}
				title="¿Estas seguro?"
				subtitleMessage="Ya existe un archivo con el mismo nombre. ¿Desea reemplazarlo?"
				firstButtonText="CANCELAR"
				firstButtonFunction={() => {
					setOpenModal(false);
				}}
				secondButtonText="CONFIRMAR"
				secondButtonFunction={() => {
					setOpenModal(false);
          saveDocument(getValues());
				}}
				/>
			<ToastContainer />
    </div>
  )
}
